/* 布局 */
//前台
import Layout from "@views/layout";

const topicmonographRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "topicmonograph",
            name: "TOPICMONOGRAPH",
            meta: {
                title: "话题专刊管理",
                sort: 1,
            },
            component: () => import("@views/business/topicmonograph/index.vue"),
            redirect: {
                name: "TOPICMONOGRAPH_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TOPICMONOGRAPH_LIST",
                    meta: {
                        title: "话题专刊管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/topicmonograph/list.vue"),
                },
                                {
                    path: "add",
                    name: "TOPICMONOGRAPH_ADD",
                    meta: {
                        title: "新增话题专刊表",
                        parentPath: '/business/topicmonograph/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicmonograph/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "TOPICMONOGRAPH_EDIT",
                    meta: {
                        title: "编辑话题专刊表",
                        parentPath: '/business/topicmonograph/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicmonograph/form.vue"),
                },
                                        ],
    },


        ],
};

export default topicmonographRouter;
